import { render } from "./DataProtection.vue?vue&type=template&id=9a144c8a&scoped=true"
import script from "./DataProtection.vue?vue&type=script&lang=js"
export * from "./DataProtection.vue?vue&type=script&lang=js"

import "./DataProtection.vue?vue&type=style&index=0&id=9a144c8a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\raubart\\Documents\\GitLab\\hyundai_shop\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a144c8a"]])

export default __exports__